export default (code, message) => ({
  code,
  message,
});
